module.exports = __webpack_public_path__ + "media/images/beyond-metrics-2025-a8d583c07057937cea69b1a11c5823ed.png";